<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'施設属性情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'施設属性情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="addFacilityAttribute()" [disabled]="!facilityAttributeFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="facilityAttributeFormGroup">
      <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">
        <mat-form-field>
          <mat-label floatLabel="always">ID</mat-label>
          <input matInput *ngIf="!isAdded" placeholder="ID" id="facilityAttributeId" formControlName="facilityAttributeId" readonly>
          <input matInput *ngIf="!!isAdded" placeholder="ID" id="facilityAttributeId" formControlName="facilityAttributeId">
          <mat-error *ngIf="facilityAttributeIdControl.invalid">{{ getErrorMessageToFacilityAttributeId() }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
          <input matInput placeholder="{{'名称' | translate}}" id="facilityAttributeName" value="{{ facilityAttribute!.attribute_names | multiName:projectLanguages:projectBaseLang }}" readonly>
          <button matSuffix mat-stroked-button color="primary" (click)="openAttributeNameDialog()">
            <mat-icon>edit</mat-icon>
          </button>
          <mat-error *ngIf="facilityAttributeNameControl.invalid">{{ getErrorMessageToFacilityAttributeName()
            }}</mat-error>
        </mat-form-field>
      </div>

    </form>
  </div>

</div>